import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'compactNumber',
	standalone: true,
})
export class CompactNumberPipe implements PipeTransform {
	transform(value: number, fractionDigits = 1): string {
		if (Math.abs(value) < 1) {
			return value.toString();
		}

		const zerosInThousand = 3;
		const suffixes = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

		const thousandPower = Math.floor(Math.log10(Math.abs(value)) / zerosInThousand);
		const index = Math.min(thousandPower, suffixes.length - 1);
		const compact = value / Math.pow(10, index * zerosInThousand);
		const rounded = Math.round(compact * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);

		return rounded + suffixes[index];
	}
}
